import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

export interface Annotation {
  id: string
  annotation_date: string
  text: string
  created_at: string
}

export function useAnnotations(siteId: string) {
  return useQuery({
    queryKey: ['sites', siteId, 'annotations'],
    queryFn: () => apiClient.get<{ annotations: Annotation[] }>(`/api/sites/${siteId}/annotations`),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000,
  })
}

export function useCreateAnnotation(siteId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: { date: string; text: string }) =>
      apiClient.post<Annotation>(`/api/sites/${siteId}/annotations`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sites', siteId, 'annotations'] })
    },
  })
}

export function useDeleteAnnotation(siteId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (annotationId: string) =>
      apiClient.delete<{ ok: boolean }>(`/api/sites/${siteId}/annotations/${annotationId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sites', siteId, 'annotations'] })
    },
  })
}
